import type { ButtonWithSurfaceMaterial } from '@seddi/scene';
import type { LoadingManager, WebGLRenderer } from '@seddi/three';
import type { ButtonGfx } from './buttonTypes';
import { load as loadMaterial } from './materialLoader';
import { load as loadMesh } from './meshLoader';

/**
 * Load button.
 * @param desc - Descriptor.
 * @param manager - Loading manager.
 */
export const load = async (
  desc: ButtonWithSurfaceMaterial,
  manager: LoadingManager,
  renderer: WebGLRenderer,
): Promise<ButtonGfx> => {
  const materialDesc = desc.buttonMaterial;
  const meshUrl = desc.geometry;

  const [geometry, material] = await Promise.all([
    loadMesh(meshUrl, manager),
    loadMaterial(materialDesc, manager, renderer),
  ]);

  return { geometry, material };
};
